import styled from "styled-components";
import { colors } from "../../../../common";

export const ErrorP = styled.p`
  color: ${colors.red};
`;
